import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { cloneElement } from "react";
import { isElement } from "./auth-service-tools175.js";
import { VisuallyHidden } from "./auth-service-tools260.js";
import { useFocusTrap } from "./auth-service-tools371.js";
import { useMergedRef } from "./auth-service-tools278.js";

function FocusTrap(_ref) {
  let {
    children,
    active = true,
    refProp = "ref",
    innerRef
  } = _ref;
  const focusTrapRef = useFocusTrap(active);
  const ref = useMergedRef(focusTrapRef, innerRef);

  if (!isElement(children)) {
    return children;
  }

  return /*#__PURE__*/cloneElement(children, {
    [refProp]: ref
  });
}

function FocusTrapInitialFocus(props) {
  return /* @__PURE__ */jsxRuntimeExports.jsx(VisuallyHidden, {
    tabIndex: -1,
    "data-autofocus": true,
    ...props
  });
}

FocusTrap.displayName = "@mantine/core/FocusTrap";
FocusTrapInitialFocus.displayName = "@mantine/core/FocusTrapInitialFocus";
FocusTrap.InitialFocus = FocusTrapInitialFocus;
export { FocusTrap, FocusTrapInitialFocus };